module.exports = __webpack_public_path__ + "assets/mediaelementjs.f03d4e53.svg";